// Header search modal
document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('search-modal');
  const input = modal.querySelector('.field__input');
  const clearBtn = modal.querySelector('.search-clear-btn');

  // Click search icon
  document.addEventListener('click', (e) => {
    if (e.target.closest('#search-toggle')) {
      modal.classList.add('active');
      const input = modal.querySelector('input[type="search"]');
      if (input) input.focus();
    }
  });
  // Close modal
  modal.addEventListener('click', (e) => {
    if (e.target === modal) modal.classList.remove('active');
  });
  // Esc key modal
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') modal.classList.remove('active');
  });
  // Search input clear btn
  if (input && clearBtn) {
    // Show close 'x' icon
    input.addEventListener('input', () => {
      clearBtn.style.display = input.value.length ? 'block' : 'none';
    });
    // Clear value
    clearBtn.addEventListener('click', () => {
      input.value = '';
      clearBtn.style.display = 'none';
      input.focus();
    });
  }
});